import request from "../utils/request";

export const getSettings = async () => {
    return await request.get("/global-settings");
};
export const getSetting = async (id) => {
    return await request.get("/global-settings/" + id);
};

export const addSetting = async (params) => {
    return await request.post("/global-settings", params);
};

export const deleteSetting = async (id) => {
    return await request.delete("/global-settings/" + id);
};

export const setSetting = async ({ id, value }) => {
    return await request.put("/global-settings/" + id, { value });
};

export const updateSetting = async ({ id, params }) => {
    return await request.patch("/global-settings/" + id, params);
};
